<template>
    <div class="ur-checkbox-wrapper" :class="wrapperClass" >
        <!--
            $ver: v0.1.1
            체크박스 Wrapper 내부에 들어갈 컨텐츠 영역 입니다. 다수의 <em>ur-checkbox</em>가 배치되어 활용됩니다.
            #The content area to be placed inside the checkbox wrapper. A number of <em>ur-checkbox</em> s are deployed and utilized.
        -->
        <slot>
            <ur-checkbox v-for="(item, i) in items"
                :key="i"
                :disabled="item.disabled"
                :value="item.value"
                v-model="checked"
            >
                {{item.text}}
            </ur-checkbox>
        </slot>
        <div v-if="messageShow" class="ur-checkbox-wrapper__message ur-validator__message" :style="$_messageStyle()">
            {{messageShow}}
        </div>
    </div>
</template>

<script>
    import urValidatorMixin from '../../../mixins/urValidator/urValidatorMixin.vue';
    // ur-checkbox-wrapper는 ur-checkbox 컴포넌트를 그룹핑해서 사용할 경우에 활용됩니다.
    // #The ur-checkbox-wrapper is used when grouping and using ur-checkbox components.
    export default {
        name: 'ur-checkbox-wrapper',
        mixins: [urValidatorMixin],
        model: {
            prop: 'checked'
        },
        inject: {
            urInput: {from:'urInput', default: () => undefined}
        },
        props: {
            // $ver: v0.1.1
            // $v-model
            // v-model로 바인딩 되는 값입니다. <em>ur-checkbox-wrapper</em>하위에 존재하는
            // <em>ur-checkbox</em>의 v-model을 덮어씁니다.(단, group이 다른 경우 제외)
            // #The value bound to v-model. Overrides the v-model of <em>ur-checkbox</em> that exists under <em>ur-checkbox-wrapper</em> (unless group is different)
            checked: {type: [Boolean, String, Array]},
            // $ver: v2.1.5
            // <em>ur-checkbox-wrapper</em>하위에 items의 정보를 바탕으로  <em>ur-checkbox</em>을 생성합니다. <em>slot</em>과 함께 쓰일 경우 <em>slot</em>이 우선순위를 갖습니다.
            // #Under the <em>ur-checkbox-wrapper</em>, create a <em>ur-checkbox</em> based on the information of that property. When used with <em>slot</em>, <em>slot</em> have priority.
            items: {type: Array, Object},
            // $ver: v0.1.1
            // 하단에 표시되는 가이드 메시지입니다. 별도의 설정이 없다면 출력되지 않습니다.
            // <em>ur-checkbox-wrapper</em>는 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
            // 메시지 출력을 원할 경우 공간확보가 필요합니다.
            // #The guide message that appears at the bottom. If there is no setting, no output.
            // #<em>ur-checkbox-wrapper</em> does not occupy space for message output.
            // #If you want to output a message, you need to make space.
            guideMessage: {type:String, default: undefined},
            // $ver: v0.1.1
            // validate를 통과한 경우 출력되는 메시지입니다.
            // 별도설정이 없다면 가이드 메시지가 출력되거나 아무런 메시지도 출력되지 않습니다.
            // <em>ur-checkbox-wrapper</em>는 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
            // 메시지 출력을 원할 경우 공간확보가 필요합니다.
            // #The message that is output if validate passes.
            // #If there is no setting, guide message or no message is printed.
            // #<em>ur-checkbox-wrapper</em> does not occupy space for message output.
            // #If you want to output a message, you need to make space.
            successMessage: {type:String, default: undefined},
            // $ver: v0.1.1
            // <em>ur-checkbox-wrapper</em>하위에 존재하는 <em>ur-checkbox</em>중에서
            // <em>ur-checkbox-wrapper</em>와 group이 같게 설정된 <em>ur-checkbox</em>만 영향을 받게됩니다.
            // wrapper와 checkbox모두 기본값은 'default'로 설정되어있습니다.
            // #<em>ur-checkbox</em> with <em>ur-checkbox-wrapper</em> set to the same <em>ur-checkbox-wrapper</em> among <em>ur-checkbox-wrapper</em> only affected.
            // #The wrapper and checkbox are both set to 'default' by default.
            group: {
                type: String,
                default: 'default'
            },
            // $ver: v0.1.2
            // <em>ur-checkbox-wrapper</em>하위에 존재하는 <em>ur-checkbox</em>를 disabled 상태로 설정합니다.
            // <em>ur-checkbox-wrapper</em>와 group 이 같게 설정된 <em>ur-checkbox</em>만 영향을 받게됩니다.
            // #Set the <em>ur-checkbox</em> under the <em>ur-checkbox-wrapper</em> to the disabled state.
            // #Only <em>ur-checkbox</em> with the same <em>ur-checkbox-wrapper</em> and group will be affected.
            // $default: false
            disabled: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // 하위 <em>ur-checkbox</em>의 크기를 medium으로 정의합니다.
            // #Define the size of the child <em>ur-checkbox</em> as medium.
            // $default: false
            medium: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: medium
            md: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.1.2
            // 하위 <em>ur-checkbox</em>의 크기를 small로 정의합니다.
            // #Define the size of the child <em>ur-checkbox</em> as small.
            // $default: false
            small: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: small
            sm: {
                type:Boolean,
                default: false,
            },
            // $ver: v2.1.5
            // $tags IDE
            // 하위 <em>ur-checkbox</em>의 크기를 설정합니다. 'medium' 또는 'small' 값을 가질 수 있습니다.
            // Set the size of the child <em>ur-checkbox</em>. It can have a 'medium' or 'small' value.
            size: {
                type: String,
                validator: function (value) {
                    return ['medium','small'].indexOf(value) !== -1;
                },
            },
            // $ver: v1.0.2
            // 메시지를 표시할 때에 fixed 형식으로 출력합니다.
            // Show message fixed style.
            fixedMessage : {type:Boolean, default:false},
            /* [FROM VALIDATOR] */
            // rules
            // disabled
            // lazy
            // noShake
            /********************/
        },
        data() {return {
            default: {
                size: 'medium'
            }
            /* [FROM VALIDATOR] */
            // hasError
            // errorMessage
            // showValid
            // shake
            /********************/
        }},
        computed: {
            $_size() {
                if(this.size) {return this.size}
                if(this.medium || this.md) {return 'medium'}
                if(this.small || this.sm) {return 'small'}
                if(this.urInput) {return this.urInput.size}
                return this.default.size;
            },
            wrapperClass() { return {
                'ur-validator--error': this.hasError === true,
                'ur-validator--valid': this.showValid && this.hasError === false,
                'ur-validator--shake': this.shake
            }},
            sharedData() {
                let rtn = {}, odf = Object.defineProperty;
                odf(rtn, "checked"     , {get:()=>this.checked});
                odf(rtn, "emit"        , {get:()=>this.emit});
                odf(rtn, "click"       , {get:()=>this.click});
                odf(rtn, 'disabled' , {get:()=>this.disabled});
                odf(rtn, 'hasError' , {get:()=>this.hasError});
                return rtn;
            },
            messageShow() {
                if(this.hasError === undefined) {
                    return this.guideMessage;
                }
                if(this.hasError === true) {
                    return this.errorMessage;
                }
                if(this.hasError === false) {
                    return this.successMessage || this.guideMessage;
                }
                return undefined;
            },
            /* [FROM VALIDATOR] */
            // isValidatable
            // el
            validateTarget() {return this.checked;}, // validation setting
            /********************/
        },
        watch: {
            validateTarget(val) {
                this.validateOnEvent(); // whenever checked value changes, execute validate() if lazy is false
            },

            successMessage: {
                immediate: true,
                handler(val) {
                    this.showValid = !!val;
                }
            },
            fixedMessage: { immediate: true, handler(v,w) {
                const $me = this;
                if(v){window.addEventListener   ('wheel', closeMessage)}
                else {window.removeEventListener('wheel', closeMessage)}
                function closeMessage() {$me.errorMessage = '';}
            }}
        },
        provide() {
            let rtn = {urCheckboxWrapper:{}}, odf=Object.defineProperty;
            rtn.urCheckboxWrapper[this.group] = this.sharedData;
            let urInput = {};
            odf(urInput, 'size', {get: ()=>this.$_size});
            rtn['urInput'] = urInput;
            return rtn;
        },
        methods: {
            /* [FROM VALIDATOR] */
            // validate()        --+
            // isValid()         --+-- exposed methods for manual validate control
            // clearValidation() --+
            // validateOnEvent() -> should be set by each component which uses urValidatorMixin
            /********************/

            emit(val) {
                // $ver: v0.1.1
                // $arg: updated v-model value
                // v-model에 설정된값(checked)을 업데이트합니다.
                // # update v-model value(checked props).
                this.$emit('input',val);
            },
            click(e) {
                // $ver: v0.1.1
                // $arg: click event
                // 클릭 시 호출되는 이벤트 입니다.
                // # This event is called when clicked.
                this.$emit('click',e);
            }
        }
    }
</script>
